<template>
  <div
    class="vue-app-map-geolocation-control"
    @click="$emit('click')"
  >
    <img
      :src="geolocationIconUrl"
      alt="Your location"
    />
  </div>
</template>
<script>
import { ICON_GEOLOCATION } from '~/rails_assets';

export default {
  name: 'AppMapGeolocationControl',
  data() {
    return {
      geolocationIconUrl: ICON_GEOLOCATION,
    };
  },
};
</script>
